import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc.ts";
import Flex from "common/Boxes/Flex.tsx";
import { phoneMinWidth } from "common/NewLook/layout.ts";

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: ${phoneMinWidth}) {
    :hover {
      background-color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.05)};
      color: ${(p) => p.theme.colors.primaryBlue};
      border-radius: 4px;
    }
  }
  ${(p) =>
    p.theme.isNewLook &&
    `
    width: 28px;
    height: 28px;
    border-radius: ${p.theme.radii.control}px;
    @media (min-width: ${phoneMinWidth(p)}) {
      :hover {
        border-radius: ${p.theme.radii.control}px;
        background-color: ${p.theme.colors.cardLightBgColor};
        svg {
          color: ${p.theme.colors.primaryBlue};
        }
      }
    }
  `}
`;
